// extracted by mini-css-extract-plugin
export default {"galleryThumbnail":"c-p_gf","galleryThumbnail_active":"c-p_gg","galleryThumbnail__image":"c-p_gh"};